var map = {
	"./gc1.png": 1062,
	"./gc2.png": 2829,
	"./gc3.png": 9588,
	"./honor/1.png": 9369,
	"./honor/2.png": 4754,
	"./honor/3.png": 9579,
	"./honor/4.png": 5716,
	"./honor/5.png": 9613,
	"./page/1.png": 1920,
	"./page/2.png": 3211,
	"./page/3.png": 2082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2617;